// Galaxy Super Theme - Premium with animations - dark only
const galaxySuper = {
    id: "galaxySuper",
    name: "Galaksi ✨",
    price: 150,
    main: "#7c4dff",
    light: "#b47cff",
    dark: "#3f1dcb",
    bg: "#1a1a2e",
    darkBg: "#0d0d1a",
    isSuper: true,
    isDarkTheme: true,
    shape: "rounded",
    surfaces: {
        // Light mode (dark-only theme, but needed as fallback)
        lightBg: '#1a1a2e',
        lightPaper: '#24243e',
        lightContainer: '#24243e',
        lightOnSurface: '#f0f0f0',
        lightOnSurfaceVariant: '#b0b0cc',
        lightOutline: '#6060a0',
        // Dark mode
        containerLowest: '#141428',
        containerLow: '#0a0a14',
        container: '#141428',
        containerHigh: '#1e1e38',
        containerHighest: '#282848',
        bright: '#323258',
        onSurface: '#e8e0ff',
        onSurfaceVariant: '#b0a0d0',
        outline: '#6060a0',
        outlineVariant: '#3a3a6a',
        // Button colors — primary
        primaryContainer: '#b47cff',
        onPrimaryContainer: '#1a0040',
        // Button colors — secondary (outlined)
        secondaryContainer: '#2a1a50',
        onSecondaryContainer: '#d4b0ff',
        // Button colors — secondary (filled)
        secondary: '#b47cff',
        onSecondary: '#1a0040',
        secondaryLight: '#3f1dcb',
        onSecondaryLight: '#ffffff',
        // Button colors — inverse
        inverseSurface: '#e8e0ff',
        onInverseSurface: '#0d0d1a',
        inverseSurfaceLight: '#0d0d1a',
        onInverseSurfaceLight: '#e8e0ff',
        // Button colors — label/text
        labelColor: '#b47cff',
        labelColorLight: '#7c4dff',
        // Status colors
        success: '#4caf50',
        successLight: '#81c784',
        successDark: '#2e7d32',
        warning: '#ed6c02',
        warningLight: '#ff9800',
        warningDark: '#e65100',
        error: '#ef5350',
        errorLight: '#ff7961',
        errorDark: '#c62828',
    },
    animations: {
        background: "shimmer",
        avatar: "glowPulse",
        taskComplete: "confetti",
        completionGlow: true,
        buttonHover: "sparkle",
    },
    effects: {
        galaxy: true,
        galaxyDensity: 0.2,
        galaxyGlowIntensity: 0.2,
        galaxySaturation: 1,
        galaxyHueShift: 140,
        galaxyTwinkleIntensity: 0.3,
        galaxyRotationSpeed: 0.1,
        galaxyStarSpeed: 0.9,
        galaxySpeed: 0.3,
    },
    modes: {
        light: {
            bg: "#1a1a2e",
            background: null,
            cardBg: "rgba(255,255,255,0.12)",
            taskPendingText: "#ffffff",
            completedByOtherBg: "rgba(255,255,255,0.08)",
        },
        dark: {
            bg: "#0d0d1a",
            background: null,
            cardBg: "rgba(255,255,255,0.12)",
            taskPendingText: "#ffffff",
            completedByOtherBg: "rgba(255,255,255,0.08)",
        },
    },
};

export default galaxySuper;
